import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import type { DrawerPortalProps } from "../types";

function DrawerPortal({ ...props }: DrawerPortalProps) {
  return <DrawerPrimitive.Portal data-slot="drawer-portal" {...props} />;
}

DrawerPortal.displayName = "Drawer.Portal";

export default DrawerPortal;
